import router from "../router/index.js";
import store from "../store/index.js";
import API from "./API.js";
import Swal from 'sweetalert2'

const Auth = {
    login(payload,cb){
        const {identifier,password} = payload;
        API.post("auth/login",{identifier,password}).then((response)=>{
            if(!response.data.status) throw Error(response.data?.message);
            localStorage.setItem("signature_ehr",response.data.user.signature);
            store.dispatch("login",{
                token: response.data.access_token,
                userId: response.data.user.id,
                profil: response.data.user.profile[0].label,
                firstName: response.data.user["first_name"],
                lastName: response.data.user["last_name"]
            });
            Swal.fire('Success',"Bienvenue sur eHR IUGB",'success');
            router.push({path:"/"});
        })
        .catch(error => Swal.fire('Erreur!!!!',error?.message,'error'))
        .finally(()=>cb());
    },
    logout(){
        API.get("auth/logout").then((response)=>{
            if(!response.data.status) throw Error(response.data?.message);
            Swal.fire('Success',"Retour à la page de connexion",'success');
            router.push({name:"signin"});
            store.dispatch("logout");
        })
        .catch(error => Swal.fire('Erreur!!!!',error?.message,'error'));
    },
    updatePassword(payload,cb){
        const {old_password,new_password} = payload;
        const formData = new FormData();
        formData.append("old_password",old_password);
        formData.append("new_password",new_password);
        API.post("auth/updatePassword",formData).then((response)=>{
            if(!response.data.status) throw Error(response.data?.message);
            Swal.fire('Success',"Mot de passe mis à jour",'success');
            // router.push({name:"signin"});
            // store.dispatch("logout");
        })
        .catch(error => Swal.fire('Erreur!!!!',error?.message,'error'))
        .finally(()=> cb());
    }
};

export default Auth;